"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _UTLabel = _interopRequireDefault(require("../../../UTLabel"));

var _UTTouchableWithoutFeedback = _interopRequireDefault(require("../../../UTTouchableWithoutFeedback"));

var _DoneTick = _interopRequireDefault(require("../DoneTick"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ImageRadioCard = function ImageRadioCard(_ref) {
  var _ref$option = _ref.option,
      _ref$option$configura = _ref$option.configuration,
      image = _ref$option$configura.image_url,
      imageSelected = _ref$option$configura.selected_image_url,
      description = _ref$option$configura.description,
      value = _ref$option.value,
      name = _ref$option.name,
      isSelected = _ref.isSelected,
      onChange = _ref.onChange,
      classes = _ref.classes;

  var handleOnChange = function handleOnChange() {
    return onChange(value);
  };

  var srcImage = isSelected && imageSelected || image;
  return _react["default"].createElement(_UTTouchableWithoutFeedback["default"], {
    className: "".concat(_stylesModule["default"].container, " ").concat(isSelected && classes.isSelected, " ").concat(classes.containerCard, "  ").concat(isSelected && _stylesModule["default"].isSelected),
    onClick: handleOnChange
  }, _react["default"].createElement("img", {
    alt: "imageRadio",
    src: srcImage,
    className: classes.image
  }), _react["default"].createElement("div", {
    className: "".concat(_stylesModule["default"].containerText, " ").concat(classes.containerText, "  ").concat(!description && _stylesModule["default"].onlyTitle)
  }, _react["default"].createElement(_UTLabel["default"], {
    className: "".concat(classes.name, " ").concat(_stylesModule["default"].text, " ").concat(isSelected && _stylesModule["default"].selectedText)
  }, name), description && _react["default"].createElement(_UTLabel["default"], {
    light: true,
    className: "".concat(classes.description, " ").concat(_stylesModule["default"].text, " ").concat(isSelected && _stylesModule["default"].selectedText)
  }, description)), isSelected && _react["default"].createElement(_DoneTick["default"], {
    classes: classes
  }));
};

ImageRadioCard.propTypes = {
  option: (0, _propTypes.shape)({
    image_url: _propTypes.string,
    imageSelected: _propTypes.string,
    value: _propTypes.string,
    name: _propTypes.string,
    description: _propTypes.string
  }),
  isSelected: _propTypes.bool,
  onChange: _propTypes.func.isRequired,
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _react.memo)(ImageRadioCard);

exports["default"] = _default;